import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import PollListItem from './PollListItem';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import classList from 'flarum/common/utils/classList';
/**
 * The `PollList` component displays a list of polls.
 */
export default class PollList extends Component {
  view() {
    const state = this.attrs.state;
    const params = state.getParams();
    const isLoading = state.isInitialLoading() || state.isLoadingNext();
    let loading;
    if (isLoading) {
      loading = m(LoadingIndicator, null);
    } else if (state.hasNext()) {
      loading = m(Button, {
        className: "Button",
        onclick: state.loadNext.bind(state)
      }, app.translator.trans('fof-polls.forum.polls_list.load_more_button'));
    }
    if (state.isEmpty()) {
      const text = app.translator.trans('fof-polls.forum.polls_list.empty_text');
      return m("div", {
        className: "PollList"
      }, m(Placeholder, {
        text: text
      }));
    }
    return m("div", {
      className: classList('PollList', {
        'PollList--searchResults': state.isSearchResults()
      })
    }, m("ul", {
      "aria-busy": isLoading,
      className: "PollList-polls"
    }, state.getPages().map(pg => {
      return pg.items.map(poll => m("li", {
        key: poll.id(),
        "data-id": poll.id()
      }, m(PollListItem, {
        poll: poll,
        params: params
      })));
    })), m("div", {
      className: "PollList-loadMore"
    }, loading));
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollList', PollList);